// src/components/ContactUsModal.jsx
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import axios from "axios";
import Swal from "sweetalert2";

const ContactUsModalContent = ({ onClose }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/contact-us`,
        form,
        { headers: { "Content-Type": "application/json" } }
      );

      await Swal.fire({
        icon: "success",
        title: "Thank You!",
        text: "We'll get back to you shortly.",
        confirmButtonColor: "#28a745",
        timer: 4000,
        timerProgressBar: true,
      });

      onClose();
    } catch (err) {
      const msg =
        (err.response?.data?.message) ||
        "Something went wrong. Please try again.";

      await Swal.fire({
        icon: "error",
        title: "Oops...",
        text: msg,
        confirmButtonColor: "#dc3545",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Full Name *</Form.Label>
          <Form.Control
            required
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="John Doe"
            disabled={loading}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email *</Form.Label>
          <Form.Control
            required
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="john@example.com"
            disabled={loading}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Phone (optional)</Form.Label>
          <Form.Control
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="+91 98765 43210"
            disabled={loading}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Company / Business (optional)</Form.Label>
          <Form.Control
            name="company"
            value={form.company}
            onChange={handleChange}
            placeholder="Acme Corp"
            disabled={loading}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Message *</Form.Label>
          <Form.Control
            required
            as="textarea"
            rows={3}
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Tell us how we can help…"
            disabled={loading}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="success" type="submit" disabled={loading}>
          {loading ? "Sending…" : "Send Message"}
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const ContactUsModal = () => {
  const [show, setShow] = useState(false);

  const handleShow = (e) => {
    e.preventDefault();
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <>
      {/* THIS IS THE <a> YOU WILL USE INSIDE <li> */}
      <a href="#" onClick={handleShow} className="nav-link fw500 color1">
        Contact Us
      </a>

      {/* MODAL */}
      <Modal show={show} onHide={handleClose} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Get in Touch</Modal.Title>
        </Modal.Header>
        <ContactUsModalContent onClose={handleClose} />
      </Modal>
    </>
  );
};

export default ContactUsModal;